import { useState } from 'react';

import { getFormRequest } from '@vyce/core/src/api/forms';
import { FormDoc } from '@vyce/core/src/types';

export const useFormData = ({ userId, companyId }: { userId: string; companyId: string }) => {
  const [form, setForm] = useState<FormDoc | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const getForm = async (id: string) => {
    if (!companyId || !userId) {
      return;
    }
    try {
      setLoading(true);
      const formRes = await getFormRequest({
        companyId,
        formId: id,
        userId,
      });
      setForm(formRes);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    loading,
    getForm,
  };
};
